export enum HorizontalAlignmentStyle {
    stretch = 0,
    start = 1,
    center = 2,
    end = 3
}
